<div id="profileBanner" class="d-flex flex-column h-100">
  <!-- Live preview - temporarly image -->
  <div id="profileText" class="profile-text" *ngIf="presentPage === profile_page">
    <div class="profile-name-title">{{profileNameValue}}</div>
    <h2 id="profileNameText" class="profile-name-text">{{profileDataSet?.profileName}}</h2>
  </div>
  <div div="livePreview" class="al_live_preview"
    [ngClass]="[tabIndex === 2 || tabIndex === 3 || tabIndex === 4 ? 'preview_padding' : '',(tabIndex === 1 && presentPage === profile_page ? 'al_live_preview_banner': '')]">
    <iposcen-content-live-preview [sidenav]="sideNav" [tabindex]="tabIndex" [presentpage]="presentPage" *ngIf="tabIndex === 0 && presentPage === profile_page">
    </iposcen-content-live-preview>
    <!-- Option to select banner function -->
    <iposcen-banner-function
      *ngIf="tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4 || tabIndex === 5"
      [imageData]="imageURL" [sidenav]="sideNav" [radioType]="radioType" (goBacktoBannerContent)="setTab($event)"
      (selectedOption)="setTabNavigation($event)" [presentpage]="presentPage"></iposcen-banner-function>
    <!-- Layout of preview -->
    <div id="layout" class="preview_layout" *ngIf="showPreviewLayout && (tabIndex === 3 || tabIndex === 4 || tabIndex === 5)">
      <div id="lcgLayout1" class="card">
        <img [ngClass]="(lCGlayout === 1) ? 'img_layout-selected1': 'img_layout1'" alt="layout 1" (click)="setLayout(1)"
          class="cursor-pointer" />
      </div>
      <div id="lcgLayout2" class="card">
        <img [ngClass]="(lCGlayout === 2) ? 'img_layout-selected2': 'img_layout2'" alt="layout 2" (click)="setLayout(2)"
          class="cursor-pointer" />
      </div>
      <div id="lcgLayout3" class="card">
        <img [ngClass]="(lCGlayout === 3) ? 'img_layout-selected3': 'img_layout3'" alt="layout 3" (click)="setLayout(3)"
          class="cursor-pointer" />
      </div>
    </div>
  </div>

  <ul *ngIf="(tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4 || tabIndex === 5)"
    class="nav nav-tabs bannernav" role="tablist">
    <li class="nav-item">
      <a class="nav-link gtmAssetLibraryBannerCarouselTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 1}"
        (click)="navigate()"><span placement="top" class="tooltipClass"
          ngbTooltip="{{editCheck?showBannerCarouselName + details:newBannerContentTitle}}">{{editCheck?
          tabTrimString(showBannerCarouselName) : tabTrimString(newBannerContentTitle) }}</span></a>
    </li>
    <li class="nav-item" *ngIf="tabIndex === 2 || radioType === globalconst.URL_EXPERIENCE">
      <a class="nav-link url-exp-tab gtmAssetLibraryBannerCarouselUrlExperience" data-toggle="tab"
        [ngClass]="{'active': tabIndex === 2}" (click)="clickable?setIndex(2):false"><span
          i18n="@@banner-carousel.nav-link.url-experience">URL
          EXPERIENCE</span></a>
    </li>
    <li class="nav-item" *ngIf="pages?.page1 && !(tabIndex === 2) && radioType !== globalconst.URL_EXPERIENCE">
      <a class="nav-link gtmAssetLibraryBannerCarouselPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
        (click)="clickable?setIndex(3):false"><span i18n="@@global.tab-nav.page1">PAGE 1</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryBannerCarouselPage1" data-toggle="tab" [ngClass]="{'active': tabIndex === 3}"
        (click)="clickable?setIndex(3):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page1">PAGE 1</span>&nbsp;</div>
          <div class="delete_page" *ngIf="pagelen > 1" (click)="clickable?openPopupBanner(delete,0):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="pages?.page2 && !(tabIndex === 2) && radioType !== globalconst.URL_EXPERIENCE">
      <a class="nav-link gtmAssetLibraryBannerCarouselPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
        (click)="clickable?setIndex(4):false"><span i18n="@@global.tab-nav.page2">PAGE 2</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryBannerCarouselPage2" data-toggle="tab" [ngClass]="{'active': tabIndex === 4}"
        (click)="clickable?setIndex(4):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page2">PAGE 2</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupBanner(delete,1):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="pages?.page3 && !(tabIndex === 2) && radioType !== globalconst.URL_EXPERIENCE">
      <a class="nav-link gtmAssetLibraryBannerCarouselPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 5}"
        (click)="clickable?setIndex(5):false"><span i18n="@@global.tab-nav.page3">PAGE 3</span></a>

      <!-- Commenting the below code for OCT release(Story: IIT2-490) -->
      <!-- <a class="nav-link gtmAssetLibraryBannerCarouselPage3" data-toggle="tab" [ngClass]="{'active': tabIndex === 5}"
        (click)="clickable?setIndex(5):false">
        <div class="page_container">
          <div class="padding_container"><span i18n="@@create-partner-content.live-preview.page3">PAGE 3</span>&nbsp;</div>
          <div class="delete_page" (click)="clickable?openPopupBanner(delete,2):false"></div>
        </div>
      </a> -->
    </li>
    <li class="nav-item" *ngIf="clickable && !checkPages() && !(tabIndex === 2)">
      <a class="nav-link gtmAssetLibraryBannerCarouselAddPage" data-toggle="tab" (click)="addPage()">
        <img src="assets/images/add_black_square_outline.svg" alt="add pages" />
      </a>
    </li>
    <li class="nav-item exit_preview" *ngIf="pages?.page1">
      <a class="nav-link gtmAssetLibraryBannerCarouselCancel" (click)="cancel();resetPage()">
        <img src="assets/images/exit_icon.svg" alt="exit without changes" />
      </a>
    </li>
  </ul>

  <!-- Main section -->
  <section *ngIf="tabIndex === 0" class="main_section al_storebanner"
    [ngClass]="{'device-bottom-padding': isDeviceBanner}">
    <div id="storeBanner" class="d-flex flex-column h-100">
      <!-- Banner Content Group Tab -->
      <!-- Heading -->
      <div id="storeBannerData" class="data_header mt-0 mb-2"
        *ngIf="presentPage === profile_page && displayBannerContentGroups?.length">
        <span class="data_title"><span i18n="@@banner-carousel.header.banner-carousel">BANNER CAROUSEL</span></span>
        <span class="data_action">
          <button type="button" id="uploadBanner"
            class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryBannerCarouselAddNewBannerCarousel"
            (click)="addNewBannerCarousel()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 4.375C10.1658 4.375 10.3247 4.44085 10.4419 4.55806C10.5592 4.67527 10.625 4.83424 10.625 5V10C10.625 10.1658 10.5592 10.3247 10.4419 10.4419C10.3247 10.5592 10.1658 10.625 10 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H9.375V5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.375 10C9.375 9.83424 9.44085 9.67527 9.55806 9.55806C9.67527 9.44085 9.83424 9.375 10 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H10.625V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V10Z" />
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75ZM10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z" />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="20" height="20" />
                </clipPath>
              </defs>
            </svg>
            <span i18n="@@banner-carousel.main-section.new-banner-carousel-btn">New Banner Content Group</span>
          </button>
        </span>
      </div>
      <div *ngIf="tabIndex === 0" id="bannerContentGroups">
        <div id="bannerContentHeaders" class="main_section_headers"
          *ngIf="presentPage === assets_page || (presentPage === profile_page && !displayBannerContentGroups?.length)"
          [ngClass]="presentPage === profile_page? 'profile_main_section_headers':''">
          <svg *ngIf="presentPage === assets_page" class="header_icon" width="24" height="24" viewBox="0 0 24 24"
            fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9 1.5H1.5V22.5H9V1.5ZM22.5 1.5H15V9H22.5V1.5ZM22.5 15H15V22.5H22.5V15ZM0 1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0L9 0C9.39782 0 9.77936 0.158035 10.0607 0.43934C10.342 0.720644 10.5 1.10218 10.5 1.5V22.5C10.5 22.8978 10.342 23.2794 10.0607 23.5607C9.77936 23.842 9.39782 24 9 24H1.5C1.10218 24 0.720644 23.842 0.43934 23.5607C0.158035 23.2794 0 22.8978 0 22.5V1.5ZM13.5 1.5C13.5 1.10218 13.658 0.720644 13.9393 0.43934C14.2206 0.158035 14.6022 0 15 0L22.5 0C22.8978 0 23.2794 0.158035 23.5607 0.43934C23.842 0.720644 24 1.10218 24 1.5V9C24 9.39782 23.842 9.77936 23.5607 10.0607C23.2794 10.342 22.8978 10.5 22.5 10.5H15C14.6022 10.5 14.2206 10.342 13.9393 10.0607C13.658 9.77936 13.5 9.39782 13.5 9V1.5ZM15 13.5C14.6022 13.5 14.2206 13.658 13.9393 13.9393C13.658 14.2206 13.5 14.6022 13.5 15V22.5C13.5 22.8978 13.658 23.2794 13.9393 23.5607C14.2206 23.842 14.6022 24 15 24H22.5C22.8978 24 23.2794 23.842 23.5607 23.5607C23.842 23.2794 24 22.8978 24 22.5V15C24 14.6022 23.842 14.2206 23.5607 13.9393C23.2794 13.658 22.8978 13.5 22.5 13.5H15Z" />
          </svg>
          <span i18n="@@banner-carousel.header.banner-carousel">BANNER CAROUSEL</span>
        </div>

        <!-- Data header with info like no. of content groups, action buttons and filters -->
        <div id="displayBanner" class="data_header"
          *ngIf="((presentPage!== undefined) && (presentPage === assets_page || profile_page))"
          [ngClass]="(displayBannerContentGroups?.length > 0)?'':'display-block'">
          <ng-container *ngIf="presentPage === assets_page">
            <span *ngIf="displayBannerContentGroups?.length > 0">
              <span id="dataTitle"
                *ngIf="displayBannerContentGroups?.length == 1">{{displayBannerContentGroups?.length}}
                <span>{{bannerCorouselLabel}}</span></span>
              <span id="dataTitle" *ngIf="displayBannerContentGroups?.length > 1">{{displayBannerContentGroups?.length}}
                <span i18n="@@banner-carousel.data-header.banner-carousel-groups">Banner Carousel Groups</span></span>
              <span *ngIf="displayBannerContentGroups?.length > 1">
                <span class="sort-by-label" i18n="@@banner-carousel.data-header.sort-by">Sort by</span>:&nbsp;
                <div id="displayBannerDropDown" ngbDropdown class="d-inline-block">
                  <button ngbDropdownToggle class="btn btn-primary btn-sm" id="sortDropDown">{{sortValue}}
                  </button>
                  <div id="displayBannerDropDownMenu" ngbDropdownMenu aria-labelledby="sortDropDown">
                    <button ngbDropdownItem *ngIf="sortValue!=createdDateVal"
                      (click)="sortBy('createDate')">{{createdDateVal}}</button>
                    <button ngbDropdownItem *ngIf="sortValue!=groupNameVal"
                      (click)="sortBy('groupName')">{{groupNameVal}}</button>
                  </div>
                </div>
              </span>
            </span>
            <span *ngIf="displayBannerContentGroups?.length === 0"
              i18n="@@banner-carousel.data-header.display-upto-3-pages">Display up to 3 Banner Carousel content groups
              of
              up to
              3
              pages on the home page of IPOS.</span>
          </ng-container>
          <ng-container *ngIf="presentPage === profile_page && displayBannerContentGroups?.length > 0">
            <div id="contentGroups">
              <div id="contentGroupsName">
                <strong><span i18n="@@banner-carousel.add-to-package.count.name">Added to Package</span>:</strong>
                {{ selctedContGrpsForProfile?.contentGrps?.length || '0'}}
                <span i18n="@@banner-carousel.add-to-package.count.contentgrps">Content Groups</span>
              </div>
              <div id="contentGroupsLabel">
                <strong><span i18n="@@banner-carousel.shown-on-device-label">Show on Device</span>:</strong>
                {{ selctedContGrpsForProfile?.showOnDevice?.length}}
                <span i18n="@@banner-carousel.add-to-package.count.contentgrps">Content Groups</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="presentPage === profile_page && !displayBannerContentGroups?.length">
            <span i18n="@@banner-carousel.data-header.display-upto-3-pages-for-shoppers">Add Banner Carousel to display
              up to 3 pages of rotating page content or a URL Experience to shoppers.</span><br />
            <strong><span i18n="@@banner-carousel.data-header.no-banner-content-group">No Banner Content Group has been
                created.</span></strong>
          </ng-container>
          <span class="data_action"
            *ngIf="presentPage === assets_page || (presentPage === profile_page && !displayBannerContentGroups?.length)">
            <button type="button" id="uploadBanner"
              class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryBannerCarouselUploadBanner"
              (click)="addNewBannerCarousel()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 4.375C10.1658 4.375 10.3247 4.44085 10.4419 4.55806C10.5592 4.67527 10.625 4.83424 10.625 5V10C10.625 10.1658 10.5592 10.3247 10.4419 10.4419C10.3247 10.5592 10.1658 10.625 10 10.625H5C4.83424 10.625 4.67527 10.5592 4.55806 10.4419C4.44085 10.3247 4.375 10.1658 4.375 10C4.375 9.83424 4.44085 9.67527 4.55806 9.55806C4.67527 9.44085 4.83424 9.375 5 9.375H9.375V5C9.375 4.83424 9.44085 4.67527 9.55806 4.55806C9.67527 4.44085 9.83424 4.375 10 4.375Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M9.375 10C9.375 9.83424 9.44085 9.67527 9.55806 9.55806C9.67527 9.44085 9.83424 9.375 10 9.375H15C15.1658 9.375 15.3247 9.44085 15.4419 9.55806C15.5592 9.67527 15.625 9.83424 15.625 10C15.625 10.1658 15.5592 10.3247 15.4419 10.4419C15.3247 10.5592 15.1658 10.625 15 10.625H10.625V15C10.625 15.1658 10.5592 15.3247 10.4419 15.4419C10.3247 15.5592 10.1658 15.625 10 15.625C9.83424 15.625 9.67527 15.5592 9.55806 15.4419C9.44085 15.3247 9.375 15.1658 9.375 15V10Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M10 18.75C12.3206 18.75 14.5462 17.8281 16.1872 16.1872C17.8281 14.5462 18.75 12.3206 18.75 10C18.75 7.67936 17.8281 5.45376 16.1872 3.81282C14.5462 2.17187 12.3206 1.25 10 1.25C7.67936 1.25 5.45376 2.17187 3.81282 3.81282C2.17187 5.45376 1.25 7.67936 1.25 10C1.25 12.3206 2.17187 14.5462 3.81282 16.1872C5.45376 17.8281 7.67936 18.75 10 18.75ZM10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="20" height="20" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@banner-carousel.main-section.new-banner-carousel-btn">New Banner Content Group</span>
            </button>
          </span>
        </div>
        <ng-container *ngIf="presentPage === profile_page && displayBannerContentGroups?.length">
          <div id="profileDataTitle" class="mt-3 mb-3">
            <span i18n="@@banner-carousel.data-header.display-upto-3-pages">Display up to 3 Banner Carousel content
              groups of up to 3 pages on the home page of IPOS.</span>
            <span i18n="@@banner-carousel.data-header.add-upto-10-pages">You may <strong>add up to 6 Banner Carousel
                content groups.</strong></span>
          </div>
        </ng-container>
        <!-- Data Content -->
        <div id="dataContentSegment" class="data_content segments_only" *ngIf="displayBannerContentGroups?.length > 0"
          [ngClass]="presentPage === profile_page?'acc_table_view':''">
          <div id="deviceSelect" class="show_on_device_select" *ngIf="presentPage === profile_page">
            <div id="showDeviceText" class="small_text border-right shown-on-device-label"><span
                i18n="@@segments.shown-on-device-label">Show on Device</span></div>
            <div id="showDeviceContent"><span i18n="@@banner-carousel.add-to-package.count.contentgrps">Content
                Groups</span></div>
          </div>
          <div class="accordion" id="logoContentAccordian">
            <!-- Group 1 -->

            <div id="logoContentCard" class="card"
              *ngFor="let bannerContentGroup of displayBannerContentGroups | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; index as i">
              <div id="logoContentCardHeader" class="card-header small_text" id="segmentOne">
                <input class="mt-3 mr-3" [disabled]='!checkedId.has(bannerContentGroup.id) && checkedId.size >= 3'
                  type="checkbox" [checked]='checkedId.has(bannerContentGroup.id)' *ngIf='isDeviceBanner'
                  (click)='getBannerDeviceData(bannerContentGroup)'>
                <div id="accCheck" class="acc_check" *ngIf="presentPage === profile_page">
                  <div id="bannerContentGroupPckg" class="form-check"
                    [ngbPopover]="((!bannerContentGroup?.addToPackage || selctedContGrpsForProfile?.showOnDevice?.length === 3) && !selctedContGrpsForProfile?.showOnDevice.includes(bannerContentGroup?.id)) ? (((selctedContGrpsForProfile?.contentGrps?.length === 6 && !bannerContentGroup?.addToPackage) || bannerContentGroup?.addToPackage===true) ? showonDeviceLimit:showonDeviceDisabled):''"
                    [placement]="changePlacement == true ? 'left' : 'right'" triggers="mouseenter:mouseleave">
                    <input type="checkbox" name="cpLCGSelect" class="form-check-input"
                      [value]="bannerContentGroup?.showOnDevice" [checked]="bannerContentGroup?.showOnDevice"
                      (change)="addToProfile($event, bannerContentGroup?.index, 'showondevice')" [disabled]="(!bannerContentGroup?.addToPackage || selctedContGrpsForProfile?.showOnDevice?.length === 3) &&
                    !selctedContGrpsForProfile?.showOnDevice.includes(bannerContentGroup?.id)" />
                  </div>
                </div>
                <div id="deviceBannerCardContent" class="card-header-content">
                  <div id="deviceBannerCardTitle" class="title_left"
                    [ngClass]="{'device-banner-background':isDeviceBanner}">
                    <div id="deviceBannerCardPublish" class="d-flex">
                      <div id="deviceBannerCardPublishTitle" class="title">
                        <span>{{bannerContentGroup?.configurations?.publishedName}} &nbsp;&nbsp;</span>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div *ngIf="(bannerContentGroup.isContentExpires)" id="contentExpire" class="content-expire"><img
                          class="contents-info-icon" alt="info_icon"><span>{{globalconst.CONT_GRP_EXPIRED_TEXT}}</span>
                      </div>
                      <div id="deviceBannerBtnSection" class="d-flex"
                        *ngIf="presentPage === assets_page && ((!bannerContentGroup.islocked && isStoreUser) || !isStoreUser)">
                        <button type="button" placement="bottom" ngbTooltip="{{editTooltipLabel}}"
                          (click)="editBanner(bannerContentGroup?.id)" class="btn gtmEditSegment">
                          <img alt="Edit" />
                        </button>
                        <button type="button" placement="bottom" ngbTooltip="{{deleteTooltipLabel}}"
                          (click)="openDeleteModal(bannerContentGroup?.id)" class="btn gtmDeleteSegment">
                          <img alt="Delete" />
                        </button>
                        <iposcen-delete-popup #deleteModal [contentName]="bannerCGToDeleteName"
                          [buttonName]="'Content Group'"
                          (delete)="deleteBannerCG(bannerCGToDelete)"></iposcen-delete-popup>
                        <button *ngIf="isRetailerUser || isRegionalHQ" type="button"
                          class="btn gtmSendBanner gtmSendBtn" placement="bottom" ngbTooltip={{optionalButton}}
                          container="body" (click)="openSendBannerCarouselToAccountModal(bannerContentGroup?.id)">
                          <img alt="Send" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="assetsBanner" *ngIf='!isDeviceBanner' class="other_data">
                    <div id="assetsBannerId">
                      <iposcen-assetid-copy [assetID]="bannerContentGroup?.id" *ngIf="presentPage === assets_page">
                      </iposcen-assetid-copy>
                      <div id="assetsSubTitle" class="subtitle_group">
                        <span class="subtitle" i18n="@@price-content.group-tab.created-by">Created By:
                          {{bannerContentGroup?.createdByUser}}</span>
                        <span class="subtitle" i18n="@@price-content.group-tab.edited-by">Last Edited By
                          {{bannerContentGroup?.createdByUser}}:
                          {{bannerContentGroup?.updateTime | dateFormat: "changeToLocalTimeZone"}}</span>
                        <span class="subtitle" *ngIf="presentPage === assets_page && userRole !== 'nonConnectedUser'"
                          i18n="@@price-content.group-tab.pushed">Pushed to all devices:
                          {{bannerContentGroup?.ispushedToDevice ? YES : NO}}</span>
                        <span *ngIf="bannerContentGroup?.configurations?.internalName"
                          class="subtitle"><span>{{internalName}}:</span>
                          {{bannerContentGroup?.configurations?.internalName}}
                        </span>
                      </div>
                      <div id="profileBannerFormCheck" class="form-check mt-3" *ngIf="presentPage === profile_page"
                        [ngbPopover]="(selctedContGrpsForProfile?.contentGrps?.length === 6 && !bannerContentGroup?.addToPackage) ? addToPackageLimit:''"
                        placement="top-left" triggers="mouseenter:mouseleave">
                        <input class="form-check-input" type="checkbox" [value]="bannerContentGroup?.addToPackage"
                          [checked]="bannerContentGroup?.addToPackage"
                          (change)="addToProfile($event, bannerContentGroup?.index, 'addtopackage')"
                          [disabled]="selctedContGrpsForProfile?.contentGrps?.length === 6 && !bannerContentGroup?.addToPackage"
                          [id]="'addToPackOne'+bannerContentGroup?.index" />
                        <label class="form-check-label" [for]="'addToPackOne'+bannerContentGroup?.index"
                          i18n="@@banner-carousel.collapse-link.add-to-package">Add to Package</label>
                      </div>
                    </div>
                    <div id="profileContentLock" class="d-flex"
                      *ngIf="presentPage === assets_page && bannerContentGroup.islocked && isStoreUser">
                      <div id="lockContentTxt" class="gtmlockIcon lock-icon">
                        <img alt="content locked" />
                        <span class="pl-1 pt-1">{{lockContentText}}</span>
                      </div>
                    </div>
                    <div id="bannerContentCheckbox" class="custom-control custom-switch"
                      *ngIf="(presentPage === assets_page) && (userRole === retailHqUser || userRole === regionalHqUser)">
                      <input type="checkbox" class="custom-control-input" [id]="'lockContent'+bannerContentGroup?.id"
                        [checked]="bannerContentGroup?.islocked" [value]="bannerContentGroup?.islocked"
                        (click)=changeLockContentStatus(bannerContentGroup?.id,$event,bannerContentGroup) />
                      <label class="custom-control-label" [for]="'lockContent'+bannerContentGroup?.id"
                        i18n="@@banner-carousel.second-group.lock-content">Lock Content</label>
                    </div>
                  </div>
                </div>
                <div id="bannerContentGroupId"
                  class="collapse_link collapsed collapse-button {{bannerContentGroup?.id}}" type="button"
                  (click)="getDetailsOfBannerCG(bannerContentGroup?.id)"
                  [ngClass]="bannerContentGroup.isExpanded ? 'transform-180' : ''">
                  <svg class="accordian_expanded" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M2.469 6.96936C2.53867 6.89952 2.62143 6.8441 2.71255 6.80629C2.80367 6.76849 2.90135 6.74902 3 6.74902C3.09865 6.74902 3.19633 6.76849 3.28745 6.80629C3.37857 6.8441 3.46133 6.89952 3.531 6.96936L12 15.4399L20.469 6.96936C20.5387 6.89963 20.6215 6.84432 20.7126 6.80658C20.8037 6.76884 20.9014 6.74942 21 6.74942C21.0986 6.74942 21.1963 6.76884 21.2874 6.80658C21.3785 6.84432 21.4613 6.89963 21.531 6.96936C21.6007 7.0391 21.656 7.12188 21.6938 7.21299C21.7315 7.3041 21.7509 7.40175 21.7509 7.50036C21.7509 7.59898 21.7315 7.69663 21.6938 7.78774C21.656 7.87885 21.6007 7.96163 21.531 8.03136L12.531 17.0314C12.4613 17.1012 12.3786 17.1566 12.2874 17.1944C12.1963 17.2322 12.0986 17.2517 12 17.2517C11.9013 17.2517 11.8037 17.2322 11.7125 17.1944C11.6214 17.1566 11.5387 17.1012 11.469 17.0314L2.469 8.03136C2.39915 7.9617 2.34374 7.87893 2.30593 7.78781C2.26812 7.6967 2.24866 7.59901 2.24866 7.50036C2.24866 7.40171 2.26812 7.30403 2.30593 7.21291C2.34374 7.1218 2.39915 7.03903 2.469 6.96936Z" />
                  </svg>
                </div>
              </div>

              <div id="collapseThree" class="collapse bannerContentPreview" #collapse="ngbCollapse"
                [(ngbCollapse)]="!bannerContentGroup.isExpanded" aria-labelledby="logoCGThree"
                data-parent="#logoContentAccordian">
                <div class="card-body" [ngClass]="presentPage === profile_page?'':'card-body-asset'">
                  <!-- IIT2-4661-->
                  <div id="bannerGroupLibrary" class="clearfix">
                    <ul class="nav nav-tabs float-left" role="tablist"
                      *ngIf="bannerContentGroup.configurations?.contentGroupPages?.length">
                      <li class="nav-item">
                        <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab"
                          [ngClass]="{'active': bannerContentGroup.previewTabIndex === 0}"
                          (click)="previewNavigate(0, bannerContentGroup.id)">
                          <span placement="top" container='body' i18n="@@hero-tile.asset-library.main-content">Main
                            content</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link gtmAssetLibraryLogoContentTitle" data-toggle="tab"
                          [ngClass]="{'active': bannerContentGroup.previewTabIndex === 1}"
                          (click)="previewNavigate(1, bannerContentGroup.id)">
                          <span placement="top" container='body' i18n="@@hero-tile.asset-library.page-content">Page
                            contents</span>
                        </a>
                      </li>
                    </ul>
                    <div id="bannerContentGroupDuplicate" class="table-container"
                      *ngIf="presentPage === assets_page || presentPage === profile_page"
                      class="duplicate-and-edit-span float-right">
                      <button type="button" class="btn btn-primary btn-sm left_icon_btn gtmDuplicateContGrp"
                        (click)="duplicateAndEditBanner(bannerContentGroup?.id)">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3 2H11C11.5304 2 12.0391 2.21071 12.4142 2.58579C12.7893 2.96086 13 3.46957 13 4V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V4C1 3.46957 1.21071 2.96086 1.58579 2.58579C1.96086 2.21071 2.46957 2 3 2V2ZM3 3C2.73478 3 2.48043 3.10536 2.29289 3.29289C2.10536 3.48043 2 3.73478 2 4V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H11C11.2652 15 11.5196 14.8946 11.7071 14.7071C11.8946 14.5196 12 14.2652 12 14V4C12 3.73478 11.8946 3.48043 11.7071 3.29289C11.5196 3.10536 11.2652 3 11 3H3Z"
                            fill="white" />
                          <path
                            d="M5 0H13C13.5304 0 14.0391 0.210714 14.4142 0.585786C14.7893 0.960859 15 1.46957 15 2V12C15 12.5304 14.7893 13.0391 14.4142 13.4142C14.0391 13.7893 13.5304 14 13 14V13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12V2C14 1.73478 13.8946 1.48043 13.7071 1.29289C13.5196 1.10536 13.2652 1 13 1H5C4.73478 1 4.48043 1.10536 4.29289 1.29289C4.10536 1.48043 4 1.73478 4 2H3C3 1.46957 3.21071 0.960859 3.58579 0.585786C3.96086 0.210714 4.46957 0 5 0V0Z"
                            fill="white" />
                        </svg>
                        <span i18n="@@banner-carousel.collapse-link.duplicate-edit">Duplicate and Edit</span>
                      </button>
                    </div>
                  </div>
                  <div id="bannerContentGroupConfig" class="tab-content">
                    <div id="bannerContentGroupConfigIndex" *ngIf="bannerContentGroup.previewTabIndex === 0"
                      id="storeLogos" class="tab-pane pl-0"
                      [ngClass]="{'active': bannerContentGroup.previewTabIndex === 0}">
                      <div id="detailpageContent" class="detailpage__content newwin_detail_page">
                        <div id="bannerContentGroupRow" class="main-container row">
                          <div id="bannerContentGroupPublishTime"
                            *ngIf="bannerContentGroup?.configurations?.publishTime && bannerContentGroup?.configurations?.expireTime"
                            class="table-borderless col-4">
                            <div id="publishingDate" class="mb-2">
                              <span class="font-weight-bold"
                                i18n="@@price-content.group-tab.publish-date-time">Publishing Date and
                                Time</span>
                              <div id="publishingTime">{{(bannerContentGroup?.configurations?.publishTime | dateFormat:
                                "24hrP")}}</div>
                            </div>
                            <div id="expireTime">
                              <span class="font-weight-bold"
                                i18n="@@price-content.group-tab.expiration-date-time">Expiration Date
                                and Time</span>
                              <div id="expireTimeTxt">{{(bannerContentGroup?.configurations?.expireTime | dateFormat:
                                "24hrP")}}</div>
                            </div>
                          </div>

                          <div class="col-3" id="bannerContentCol">
                            <div id="bannerContentImageSection" class="image-section">
                              <img src={{bannerContentGroup?.imageUrl}} alt="Main Tile image" />
                              <div id="bannerContentThumbnail">
                                <div id="bannerContentTxt" class="font-weight-bold">Banner Thumbnail</div>
                                <div id="bannerContentImageFile">{{bannerContentGroup?.configurations?.imageFile}}</div>
                              </div>
                            </div>
                          </div>
                          <table class="table-borderless form-factors-main-div col-3" aria-describedby="formFactors">
                            <tr>
                              <th scope="col"><span i18n="@@banner-carousel.content-group-applies-to">Content Group
                                  Applies
                                  To</span></th>
                            </tr>
                            <tr>
                              <td><strong><span>{{deviceTypes}}</span>: </strong>
                                {{ bannerContentGroup?.configurations?.formFactor?.devices}}</td>
                            </tr>
                            <tr>
                              <td><strong><span>{{manufacturers}}</span>:</strong>
                                {{ bannerContentGroup?.configurations?.formFactor?.manufacturer}}</td>
                            </tr>
                            <tr>
                              <td><strong><span>{{processors}}</span>: </strong>
                                {{ bannerContentGroup?.configurations?.formFactor?.processors}}</td>
                            </tr>
                            <tr>
                              <td><strong><span>{{generation}}</span>:</strong>
                                {{ bannerContentGroup?.configurations?.formFactor?.generations}}</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div id="contentGroupPages" *ngIf="bannerContentGroup.previewTabIndex === 1" id="storeLogos"
                      class="tab-pane pl-0" [ngClass]="{'active': bannerContentGroup.previewTabIndex === 1}">
                      <div id="contentGroupContainer" class="main-container">
                        <div id="contentGroupConfig" class="d-flex ">
                          <ng-container *ngFor="let page of bannerContentGroup.configurations.contentGroupPages">
                            <iposcen-mini-live-preview [data]="loadMiniPreview(bannerContentGroup?.id,page)">
                            </iposcen-mini-live-preview>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- IIT2-4661 end-->
                </div>
              </div>

            </div>
            <iposcen-send-to-segment-account #sendToAccountModal [sendName]="sendNameToStore"
              [sendButtonName]="sendButtonText" (selectedStoreData)="getSelectedStoreData($event)"
              [sendToStoreSuccess]="isSendToStore" (clearAllData)="isSendToStore=false">
            </iposcen-send-to-segment-account>

          </div>
        </div>

        <!-- Data Footer - Pagination -->
        <div id="contentGroupDataFooter" class="data_footer">
          <nav aria-label="banner content pagination"
            *ngIf="displayBannerContentGroups && displayBannerContentGroups?.length">
            <ngb-pagination [collectionSize]="displayBannerContentGroups?.length" [(page)]="page" [pageSize]="pageSize"
              [rotate]="true" [maxSize]="maxSize" [ellipses]="true" [boundaryLinks]="false"></ngb-pagination>
          </nav>
        </div>
      </div>
      <div id="contentGroupBtn" class="button-wrapper justify-content-end" *ngIf="presentPage === profile_page">
        <button type="button" class="btn btn-outline-primary gtmAssetLibraryBannerCarouselSkip"
          (click)="sendToProfile('skip')">
          <span i18n="@@banner-carousel.footer.skip">Skip</span>
        </button>
        <button type="button" class="btn btn-primary gtmAssetLibraryBannerCarouselSaveAndProceed"
          (click)="sendToProfile('send')" [disabled]="displayBannerContentGroups?.length === 0">
          <span class="gtmAssetLibraryBannerCarouselSaveAndProceed"
            i18n="@@logo-content.logo-content-groups.save-and-continue">Save and Continue</span>
        </button>
      </div>
    </div>
  </section>
  <!-- Create New banner section -->
  <section *ngIf="tabIndex === 1 || tabIndex === 2 || tabIndex === 3 || tabIndex === 4 || tabIndex === 5"
    class="main_section al_newbanner">
    <ng-container>
      <div id="bannerCarousel" *ngIf="tabIndex === 1">
        <iposcen-create-banner-carousel [bannerFunction]="bannerFunction" [presentpage]="presentPage"
          (goBacktoBannerContent)="setCreatedGrpID($event)">
        </iposcen-create-banner-carousel>
      </div>
      <div id="bannerUrl" *ngIf="tabIndex === 2">
        <iposcen-banner-url [cntgrpdata]="contentGrpData" [contentGroupType]="pageType"></iposcen-banner-url>
      </div>
      <div id="bannerPage1" *ngIf="tabIndex === 3">
        <iposcen-page #page1 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=1
          [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshBannerContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div id="bannerPage2" *ngIf="tabIndex === 4">
        <iposcen-page #page2 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=2
          [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshBannerContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
      <div id="bannerPage3" *ngIf="tabIndex === 5">
        <iposcen-page #page3 [cntgrpdata]="contentGrpData" [contentGroupType]="pageType" [pageNumber]=3
          [mediaObjs]="mediaObjects" (goBacktoLogoContent)="refreshBannerContentdata()"
          (isBodyError)='getPageError($event)' (sendLayoutTocontentGrp)="setPreviewLayout($event)"></iposcen-page>
      </div>
    </ng-container>
    <iposcen-showon-device #showModal (show)="showOnDevice()" (closePopup)="closeShowOnDevice()">
    </iposcen-showon-device>
    <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
    </iposcen-apply-changes-to-devices>
    <div id="urlBtnWrapper" class="url_button-wrapper" *ngIf="tabIndex === 2">
      <button type="button" (click)="cancel()" class="btn btn-outline-primary gtmAssetLibraryBannerCarouselCancel">
        <span i18n="@@banner-carousel.footer.cancel">Cancel</span>
      </button>
      <button type="button" (click)="updateBCG()" class="btn btn-primary gtmAssetLibraryBannerCarouselSaveAndProceed"
        [disabled]="!customURL?.trim()">
        <span i18n="@@banner-carousel.footer.save">Save and Proceed</span>
      </button>
    </div>
    <div id="addPage" class="button-wrapper mb-4 mr-4 footer-buttons" style="justify-content: flex-end"
      *ngIf="tabIndex === 3 || tabIndex === 4 || tabIndex === 5">
      <button type="button" class="btn btn-outline-primary left_icon_btn gtmAddPageLogo" (click)="addPage()"
        *ngIf="!isPage3Created">
        <img src="assets/images/plus_square_outline.svg" alt="add page" />
        <span i18n="@@banner-carousel.footer.add-page">Add Page</span>
      </button>
      <button type="button" class="btn btn-primary gtmSaveLogoContGrp"
        (click)="pageError.get(1)||pageError.get(2)||pageError.get(3)?openPopup(errorPopup):updateBCG()">
        {{buttonName}}
      </button>
    </div>
  </section>
</div>
<!-- //popup page delete  -->
<ng-template #delete let-modal>
  <div id="confrmPopUp" class="card confirmPopup">
    <div id="modalHeader" class="modal-header">
      <div id="modalCloseIcon" (click)="modal.close()" class="close-icon">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="modalBody" class="modal-body popup-body">
      <div id="modalBodyTitle">
        <h2 class="mt-3">
          <span i18n="@@create-partner-content.delete-modal.delete-page?">Delete Page?</span>
        </h2>
        <div id="modalBodyText" class="card-desc">
          <span i18n="@@create-partner-content.delete-modal.remove-permanently">This content will be removed
            permanently.</span>
        </div>
      </div>
    </div>
    <div id="modalFooter" class="modal-footer card-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@create-partner-content.delete-modal.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-confirm" (click)="modal.close();deletePages(whichPageDelete)">
        <span i18n="@@create-partner-content.delete-modal.delete-page">Delete Page</span>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #errorPopup let-modal>
  <div id="confirmErrPopup" class="card confirmPopup">
    <div id="confirmErrPopupHeader" class="modal-header">
      <div id="confirmErrClose" (click)="modal.close()" class="close-icon">
        <img src="../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="confirmErrPopupModalBody" class="modal-body popup-body">
      <div id="confirmErrPopupModalBodyDesc">
        <div id="confirmErrPopup" class="card-desc">
          <span *ngIf='pageError.get(1) && !pageError.get(2) && !pageError.get(3)'>{{errorMessageText}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(2)  && !pageError.get(3)'>{{errorMessageText1}}</span>
          <span *ngIf='pageError.get(1) && pageError.get(3)  && !pageError.get(2)'>{{errorMessageText2}}</span>
          <span *ngIf='pageError.get(2) && !pageError.get(3) && !pageError.get(1)'>{{errorMessageText3}}</span>
          <span *ngIf='pageError.get(2) && pageError.get(3)  && !pageError.get(1)'>{{errorMessageText4}}</span>
          <span *ngIf='pageError.get(3) && !pageError.get(1) && !pageError.get(2)'>{{errorMessageText5}}</span>
          <span *ngIf='pageError.get(3) && pageError.get(1) && pageError.get(2)'>{{errorMessageText6}}</span>
        </div>
      </div>
    </div>
    <div id="confirmErrPopupModalClose" class="modal-footer card-footer">
      <button type="button" (click)="modal.close();goToErrorPage()" class="btn btn-primary btn-confirm">
        <span>{{buttonLable}}</span>
      </button>
    </div>
  </div>
</ng-template>